import React, { Component } from 'react'

export default class IandA extends Component {
    render() {
        return (
            <svg className={this.props.className} onClick={this.props.onClick} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.1328 22.6641C12.1328 22.6641 20.1328 18.6641 20.1328 12.6641V5.66406L12.1328 2.66406L4.13281 5.66406V12.6641C4.13281 18.6641 12.1328 22.6641 12.1328 22.6641Z" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
            <path d="M15.2503 10.9417L11.5768 14.6153L9.62722 12.6658" stroke="#001F82" strokeWidth="1.4" stroke-linecap="round" strokeLinejoin="round"/>
            </svg>
        )
    }
}
